<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Data Management</h6>
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
      <!-- Card stats -->
      <b-row>
        <b-col xl="12">
          <b-card no-body>
            <b-card-body>
              <b-tabs content-class="mt-3">
                <b-tab title="TopOff Payments">
                  <TopOffPayments></TopOffPayments>
                </b-tab>
                <b-tab title="TopOff Plans">
                  <TopOffPlans></TopOffPlans>
                </b-tab>
                <b-tab title="Mobile Data Plans">
                  <MobileDataPlans></MobileDataPlans>
                </b-tab>
                <b-tab title="Mobile Balance Check">
                  <MobileBalanceCheck></MobileBalanceCheck>
                </b-tab>
                <b-tab title="Broadband Data Plans">
                  <BroadbandDataPlans></BroadbandDataPlans>
                </b-tab>
                <b-tab title="Broadband Balance Check">
                  <BroadbandBalanceCheck></BroadbandBalanceCheck>
                </b-tab>
              </b-tabs>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">

    </b-container>
  </div>
</template>

<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
  import TopOffPayments from "./TopOffPayments";
  import TopOffPlans from "./TopOffPlans";
  import MobileDataPlans from "./MobileDataPlans";
  import MobileBalanceCheck from "./MobileBalanceCheck";
  import BroadbandDataPlans from "./BroadbandDataPlans";
  import BroadbandBalanceCheck from "./BroadbandBalanceCheck";
    export default {
        name: "Data-Management",
      components: {
        BroadbandBalanceCheck,
        BroadbandDataPlans,
        MobileBalanceCheck,
        MobileDataPlans,
        TopOffPlans,
        TopOffPayments,
        RouteBreadCrumb,
      },
      mounted() {
        document.title = 'DCC Portal | Data Management';
      }
    }
</script>

